import { gql } from '@apollo/client'

export const IPL_AUCTION_TEAMS = gql`
  query ListAuctionTeamFront($input: oListAuctionTeamFrontInput) {
    listAuctionTeamFront(input: $input) {
      sMessage
      aData {
        _id
        nTotalSpent
        nPurseLeft
        nPlayerCount
        nOverseaPlayerCount
        sColorCode
        oSeo {
          sSlug
        }
        oTeam {
          _id
          oImg {
            sUrl
          }
          sAbbr
          sAltName
        }
      }
    }
  }
`
export const auctionPlayer = `
_id
nBasePrice
nSoldPrice
bCappedPlayer
bOverseas
oTeam {
  sAbbr
  oImg {
    sUrl
    sText
  }
}
eAuctionStatus
oPrimaryTeam {
  sTitle
  oImg {
    sUrl
    sText
  }
  oJersey {
    sUrl
    sText
  }
}
oPlayer {
  sFullName
  oImg {
    sUrl
    sText
  }
}
oCountry {
  sTitle
  oImg {
    sUrl
    sText
  }
}
sPlayingRole
`
export const IPL_AUCTION_TEAMS_BY_ID = gql`
  query GetAuctionTeamFront($input: oGetAuctionTeamFrontInput!) {
    getAuctionTeamFront(input: $input) {
      oData {
        _id
        nTotalSpent
        nPurseLeft
        nPlayerCount
        nOverseaPlayerCount
        sColorCode
        oTeam {
          _id
          oImg {
            sUrl
          }
          sAbbr
          sAltName
          sTitle
        }
        aAllRounderPlayer{
          ${auctionPlayer}
        }
        aBatterPlayer {
          ${auctionPlayer}
        }
        aBowlerPlayer {
          ${auctionPlayer}
        }
        aWicketKeeperPlayer {
          ${auctionPlayer}
        }
      }
    }
  }
`
